module.exports = __webpack_public_path__ + "static/stone-style-1-2645a132677b605635039e1e33d08bbc.png";